import React, { Suspense } from 'react';
import { Hero } from '../components/sections/Hero';
import { LoaderSpinner } from '../components/ui/LoaderSpinner';

const Projects = React.lazy(() =>
  import('../components/sections/Projects').then((module) => ({ default: module.Projects }))
);
const Timeline = React.lazy(() =>
  import('../components/sections/Timeline').then((module) => ({ default: module.Timeline }))
);
const Team = React.lazy(() =>
  import('../components/sections/Team').then((module) => ({ default: module.Team }))
);
const Contact = React.lazy(() =>
  import('../components/sections/Contact').then((module) => ({ default: module.Contact }))
);

const SectionLoader = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <LoaderSpinner />
  </div>
);

export const Home: React.FC = () => {
  return (
    <main className="bg-rs-bg min-h-screen">
      <Hero />
      <Suspense fallback={<SectionLoader />}>
        <Projects />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Timeline />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Team />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <Contact />
      </Suspense>
    </main>
  );
};
